'use client'

/**
 * WDYR Provider
 * 
 * 개발 환경에서만 why-did-you-render를 활성화합니다.
 * Next.js App Router에서 사용하기 위한 wrapper입니다.
 */

import { ReactNode } from 'react'

// 개발 환경에서만 wdyr import
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  require('@/utils/wdyr')
}

interface WDYRProviderProps {
  children: ReactNode
}

export default function WDYRProvider({ children }: WDYRProviderProps) {
  return <>{children}</>
}

